import React from "react";
import PricingCard from "./components/shared/PricingCard";
import RateItem from "./components/shared/RateItem";
import getPricingDataById from "./utils/get-pricing-data-by-id";
import useSalesFormStore from "../../../../../../../../stores/sales-form";
import formatPercentage from "./utils/format-percentage";
import formatCurrency from "./utils/format-currency";
import styles from "./style.module.scss";

const Surcharge = () => {
  const applicationData = useSalesFormStore((state) => state.applicationData);
  return (
    <div className={styles.surcharge}>
      <PricingCard>
        <div className={styles.ratesList}>
          <RateItem
            label="Surcharge Rate"
            value={formatPercentage(
              getPricingDataById(35, applicationData?.prices)?.percent,
            )}
          />
          <RateItem
            label="Per Txn"
            value={formatCurrency(
              getPricingDataById(35, applicationData?.prices)?.dollars,
            )}
          />
          <RateItem
            label="Monthly Fee"
            value={`${formatCurrency(getPricingDataById(17, applicationData?.prices)?.dollars)}/mo`}
          />
        </div>
      </PricingCard>
    </div>
  );
};

export default Surcharge;
